import { render, staticRenderFns } from "./betSlipParlay.vue?vue&type=template&id=856f37ac&lang=pug&"
import script from "./betSlipParlay.vue?vue&type=script&lang=js&"
export * from "./betSlipParlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports